let lastCachedWidth = 0
let lastCachedHeight = 0

export function createCarousel() {
    let init = (self) => {
        const page = $(self.attr("href"))
        const carousel = new Carousel(page.find(".carousel"))
        carousel.init()
        carousel.startAnimation()

        self.on("shown.bs.tab", () => {
            carousel.startAnimation()
        })
        self.on("hidden.bs.tab", () => {
            carousel.stopAnimation()
            carousel.currentPage = 0
            carousel.resetGroups()
        })
    }

    $(".tab-trigger:not(.active)").one("shown.bs.tab", e => {
        init($(e.target))
    })
    init($("li.active .tab-trigger"))
}

const INTERVAL = 5000


class Carousel {

    element: JQuery
    groupCount: number
    pages: JQuery[] = []

    currentPage = 0

    private intervalHandle: number

    constructor(elm: JQuery) {
        this.element = elm
    }

    init() {
        this.regroup()
        this.appendIndicators()
        this.startAnimation()
    }

    startAnimation() {
        window.clearInterval(this.intervalHandle)
        this.intervalHandle = window.setInterval(() => {this.scrollToNextPage()}, INTERVAL)
    }

    stopAnimation() {
        window.clearInterval(this.intervalHandle)
    }

    regroup() {
        this.pages = []
        this.currentPage = 0

        let selfWidth: number
        selfWidth = this.element.innerWidth()
        lastCachedWidth = selfWidth
        this.groupCount = selfWidth >= 900 ? 3 : (selfWidth >= 600 ? 2 : 1)

        const items = this.element.find(".carousel-item")
        const groups = this.element.find(".carousel-group")
        items.remove()
        groups.remove()

        let c = this.groupCount
        let d = 0

        let currGroup = $(`<div class="carousel-group carousel-${this.groupCount} active" data-page="${d}"></div>`)

        items.each((i, e) => {
            const item = $(e)
            if (c == 0) {
                c = this.groupCount
                this.element.append(currGroup)
                this.pages[d] = currGroup
                d += 1
                currGroup = $(`<div class="carousel-group carousel-${this.groupCount}" data-page="${d}"></div>`)
            }
            currGroup.append(item)
            c -= 1
        })

        this.element.on("transitionend", ".carousel-group", (e) => {
            const self = $(e.target)
            this.resetGroups()
        })

        this.element.append(currGroup)
        this.pages[d] = currGroup

        this.element.height(this.element.find(".carousel-item").outerHeight())
    }

    appendIndicators() {
        const indicators = $(`<div class="carousel-indicators">` +
            this.pages.map((_, i) => `<div class="indicator ${i === this.currentPage ? 'active' : ''}" data-id="${i}"></div>`).join('') +
        `</div>`)
        indicators.find(".indicator").on("click", (e) => {
            this.scrollTo(parseInt($(e.target).data("id")))
        })
        this.element.append(indicators)
    }

    resetGroups() {
        this.pages.forEach((pg, i) => {
            if (i !== this.currentPage)
                pg.removeClass("active")
        })
    }

    scrollTo(page: number, manually = true) {
        if (page < 0 || page >= this.pages.length || page === this.currentPage) return

        const thisPage = this.pages[this.currentPage]
        const newPage = this.pages[page]

        const fromLeft = page < this.currentPage
        const offset = this.pages[this.currentPage].outerWidth() * (fromLeft ? -1 : 1)

        this.currentPage = page

        newPage.addClass("active")
            .css("transition-property", "none")
            .css("transform", `translateX(${offset}px)`)

        window.setTimeout(() => {
            newPage.css("transition-property", "transform")
            window.setTimeout(() => {
                newPage.css("transform", `translateX(0px)`)
                thisPage.css("transform", `translateX(${-offset}px)`)
            })
        })

        this.element.find(".indicator").each((_, e) => {
            const indicator = $(e)
            if (parseInt(indicator.data("id")) === page) {
                indicator.addClass("active")
            } else {
                indicator.removeClass("active")
            }
        })

        if (manually) {
            this.stopAnimation()
            this.startAnimation()
        }
    }

    scrollToNextPage() {
        let nextPage = this.currentPage + 1
        if (nextPage >= this.pages.length) {
            nextPage = 0
        }
        this.scrollTo(nextPage, false)
    }
}



// WEBPACK FOOTER //
// ./dovirus/static/carousel.ts